import React from 'react'
import { Grid, GridCellProps, GridColumn } from '@progress/kendo-react-grid'
import AddButton from 'components/AddButton/AddButton'
import { FlexBox } from 'components/Box'
import { FormBaseFieldBlock, FormBaseFieldGroup } from 'components/Form/Form.styles'
import MoreButton from 'components/MoreButton/MoreButton'

interface CampaignBusinessRulesTableProps {
  businessRules: BusinessRule[]
  isEdit: boolean
  onAdd?(): void
  onEdit?(value: BusinessRule): void
  onRemove?(value: BusinessRule): void
  className?: string
}

export type BusinessRule = {
  id: string
  type: { id: number; name: string | null }
  rule: { id: number; name: string | null }
  value: number | null
}

interface MoreButtonItemProps {
  name: string
  onClick(): void
  disabled: boolean
}

export const CampaignDetailsBusinessRulesTable: React.FC<CampaignBusinessRulesTableProps> = (
  props
) => {
  const { businessRules, isEdit, onAdd, onEdit, onRemove } = props

  return (
    <FormBaseFieldBlock>
      <FormBaseFieldGroup style={{ flexDirection: 'column', alignItems: 'stretch' }}>
        <FlexBox>
          <AddButton
            disabled={!isEdit || !onAdd}
            text='Add Business Rule'
            onClick={() => onAdd && onAdd()}
          />
        </FlexBox>
        <Grid data={businessRules} resizable className={props.className}>
          <GridColumn field='type.name' title='Type' />
          <GridColumn field='rule.name' title='Rule' />
          <GridColumn field='value' title='Value' />
          <GridColumn
            field='Action'
            width={80}
            cell={(x: GridCellProps) => {
              const data = x.dataItem as BusinessRule
              return (
                <td>
                  <MoreButton
                    items={[
                      onEdit
                        ? {
                            name: 'Edit',
                            onClick: () => onEdit(data),
                            disabled: !isEdit,
                          }
                        : undefined,
                      onRemove
                        ? {
                            name: 'Delete',
                            onClick: () => onRemove(data),
                            disabled: !isEdit,
                          }
                        : undefined,
                    ].filter((item): item is MoreButtonItemProps => !!item)}
                  />
                </td>
              )
            }}
          />
        </Grid>
      </FormBaseFieldGroup>
    </FormBaseFieldBlock>
  )
}
